// noinspection GraphQLUnresolvedReference

import { gql } from "graphql-request";

export const SCENARIO_QUERY = gql`
    mutation ExecuteGetScenarioList($inOwner: String!, $inUserSID: UUID!) {
        executeGetScenarioList(inOwner: $inOwner, inUserSID: $inUserSID) {
            ScenarioID
            ScenarioOwner
            ScenarioTitle
            BaseLineID
            PrivateFlag
            DateCreated
            ScenarioDescription
            Jurisdiction
            ScenarioEditable
        }
    }
`;

export const CREATE_SCENARIO = gql`
    mutation ExecuteCreateScenario($owner: String!, $title: String!, $desc: String!, $juri: String!, $inUserSID: UUID! ) {
        executeCreateScenario(
            inScenarioOwner: $owner
            inScenarioTitle: $title
            inScenarioDescription: $desc
            inJurisdiction: $juri
            inUserSID: $inUserSID
        ) {
            ScenarioID
        }
    }
`;

export const CREATE_BASE_ON_SCENARIO = gql`
    mutation ExecuteCreateScenario($base: String!, $title: String!, $desc: String!) {
        executeCreateBaseOnScenario(
            inScenarioID: $base
            inNewScenarioTitle: $title
            inNewScenarioDescription: $desc
        ) {
            ScenarioID
        }
    }
`;

export const DELETE_SCENARIO = gql`
    mutation ExecuteDeleteScenario($inScenarioID: UUID!) {
        executeDeleteScenario(inScenarioID: $inScenarioID) {
            result
        }
    }
`;

export const UPLOAD_SCENARIO = gql`
    mutation ExecuteUploadScenarioProjects(
       $inScenarioID: UUID!
       $inProjectJSON: String!
    ) {
        executeUploadScenarioProjects(
          inScenarioID: $inScenarioID
          inProjectJSON: $inProjectJSON
        ) {
            result
        }
    }
`;
